"use client";
import Link from "next/link";
import { renderButtonStyle } from "../utils/render-button-style";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HighlightedText from "./HighlightedText";

gsap.registerPlugin(ScrollTrigger);

interface ClickToActionProps {
  titleClickToAction: string;
  backgroundColor: string;
  textColor: string;
  action: {
    url: string;
    newTab: string;
    text: string;
    type: string;
  };
}

export default function ClickToAction({ data }: { data: ClickToActionProps }) {
  const ctaWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctaWrapper = ctaWrapperRef.current;
    if (data && ctaWrapper) {
      const ctaText = ctaWrapper.querySelectorAll(".ctaText");
      const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

      tl.fromTo(
        ctaText,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.7,
          ease: "slow(0.4, 0.4, false)",
          stagger: 0.2,
        }
      );

      ScrollTrigger.create({
        trigger: ctaWrapperRef.current,
        start: "top 60%",
        end: "bottom 10%",
        animation: tl,
        onEnter: () => tl.play(),
        onLeaveBack: () => tl.reverse(),
        // markers: true
      });
    }
  }, []);

  return (
    <section
      className={`w-full px-[24px] py-[80px] md:py-[120px] flex flex-col justify-center gap-6  items-center text-xl `}
      style={{
        backgroundColor: data.backgroundColor,
        color: '#032D60',
      }}
    >
      <HighlightedText
        text={data.titleClickToAction}
        tag='h2'
        className='!leading-[1.45] text-3xl text-center font-bold'
      />
      <div className="flex flex-col items-center justify-center ctaText">
        {/* <p className="!leading-[1.45] text-3xl text-center font-bold mb-[32px]"> {data.titleClickToAction} </p> */}
        <Link
          href={data.action.url}
          target={data.action.newTab ? "_blank" : "_self"}
          className="bg-[#032D60] hover:bg-[#0095eb] text-white  border flex justify-center items-center rounded-lg py-3 px-7 font-medium text-xl md:text-base transition-all duration-300"
        >
          {data.action.text}
        </Link>
      </div>
    </section>
  );
}
